import HTTP from "@/_helpers/http";
import { INACTIVEACCOUNTS__API } from "@/_helpers/urls";
import { INACTIVEACCOUNTS__MUTATIONS } from "../mutation-types";
import { INACTIVEACCOUNTS__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
  accounts: [],
  isLoading: false,
  totalAccounts: 0,
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 1,
    lastPage: 1
  }
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [INACTIVEACCOUNTS__MUTATIONS.INACTIVEACCOUNTS](state, data) {
    state.accounts = data?.data?.accounts;
    state.totalAccounts = data?.data?.totalAccounts;
    state.pagination = data?.data?.pagination;
  },
  SET_LOADING(state, data) {
    state.isLoading = data;
  }
};

// Actions
const actions = {
  async [INACTIVEACCOUNTS__ACTIONS.INACTIVEACCOUNTS]({ commit, state }, parameter = {}) {
    try {
      commit("SET_LOADING", true);
      const {
        page = 1,
        limit = 10,
        search = ""
      } = parameter;

      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(search && { search })
      }).toString();

      const response = await HTTP().get(
        `${INACTIVEACCOUNTS__API.INACTIVEACCOUNTS}${queryParams ? `?${queryParams}` : ''}`
      );
      commit(INACTIVEACCOUNTS__MUTATIONS.INACTIVEACCOUNTS, response.data);
      commit("SET_LOADING", false);
    } catch (error) {
      console.log(error);
    }
  },

  async [INACTIVEACCOUNTS__ACTIONS.INACTIVEACCOUNTDISABLE]({ commit }, parameters) {
    try {
      const url = INACTIVEACCOUNTS__API.INACTIVEACCOUNTDISABLE;
      const allResponses = [];

      for(let parameter of parameters) {
        try {
          const response = await HTTP().patch(url, parameter);
          if (response.status === 200) {
            allResponses.push({ success: true, message: response.data.message || "Updated Successfully" });
          }
        } catch (error) {
          console.log(error);
          allResponses.push({ success: false, message: error.response?.data?.message || "Failed to update" });
        }
      }

      if (allResponses.length > 1) {
        const successCount = allResponses.filter(res => res.success).length;
        const errorCount = allResponses.filter(res => !res.success).length;
  
        if (errorCount === 0) {
          toast.success(`All ${successCount} rows disabled and deleted successfully!`);
          return {success: true}
        } else if (successCount === 0) {
          toast.error(`All ${errorCount} rows failed to disable and delete.`);
        } else {
          toast.warning(`${successCount} rows disabled and deleted successfully, ${errorCount} rows failed.`);
        }
      } else {
        toast.success(`row disabled and deleted successfully`);
      }
    } catch (error) {
      console.log(error);
      toast.error("An unexpected error occurred while processing the request.");
      return {success: false}
    }
  }
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
